import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_input = _resolveComponent("el-input");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, {
        label: _ctx.label,
        description: _ctx.description,
        required: _ctx.required
    }, {
        default: _withCtx(() => [
            _createVNode(_component_el_input, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                autosize: _ctx.autosize || { minRows: 1 },
                type: "textarea",
                placeholder: _ctx.placeholder || 'Input text here',
                disabled: _ctx.disabled
            }, null, 8 /* PROPS */, ["modelValue", "autosize", "placeholder", "disabled"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "description", "required"]));
}
